/* eslint-disable */
import {
  Component,
  Input,
  Output,
  EventEmitter,
  ViewChild,
} from '@angular/core';
import { FlowManagerService } from '../../shared/services/flowmanager.service';
import { ModalService } from '../../shared/services/modal.service';
import { LoggerService } from '../../shared/services/logger.service';
import { Router } from '@angular/router';
import { ApplicationProxyService } from '../../shared/services/applicationproxy.service';
import { SelectOptionsService } from '../../shared/services/selectoptions.service';
import { Validation } from '../../shared/services/validation.service';
import { NgRedux } from '@angular-redux/store';
import { DTMService } from '../../shared/services/dtm.service';
import { ApplicationActions } from '../../actions/application.actions';
import * as _ from 'lodash';
import { BasicInfoLabel } from '../../shared/models/Enum/ProgressBarSteps';
import { stepSubtitles } from '../../shared/models/Enum/StepSubtitles';
import { InputPaths } from '../../shared/models/Enum/InputPaths';

@Component({
  selector: 'md-formfactory',
  template: require('./formfactory.component.html'),
})
export class FormfactoryComponent {
  @Input() form;
  @ViewChild('formFactory') formElement;
  @Output() valueChange = new EventEmitter();
  @Output() updateBtnClicked = new EventEmitter();
  @Output() forgetPasswordClicked = new EventEmitter();
  @Output() hyperlinkClicked = new EventEmitter();
  @Output() launchModal = new EventEmitter();

  constructor(
    validation: Validation,
    logService: LoggerService,
    flowManager: FlowManagerService,
    modal: ModalService,
    router: Router,
    appProxy: ApplicationProxyService,
    appActions: ApplicationActions,
    optionsService: SelectOptionsService,
    ngRedux: NgRedux,
    dtm: DTMService
  ) {
    this.isValidMap = {};
    this.inputValues = {};
    this.bufferIsValidMap = {};
    this.flowManager = flowManager;
    this.modal = modal;
    this.router = router;
    this.appProxy = appProxy;
    this.appActions = appActions;
    this.validation = validation;
    this.optionsService = optionsService;
    this.logService = logService;
    this.dtm = dtm;
    this.ngRedux = ngRedux;
    this.loadState();
    this.afterInitQueue = [];
    this.validationSubscription = this.validation.validationCheck.subscribe(
      (event) => this.validCheck(event)
    );
    this.finishedInit = false;
    this.submitError = false;
  }

  //Have to map the what is required
  ngOnInit() {
    // Create variables that form factory needs from the form definition
    this.inputFields = this.form.inputs;
    this.id = this.form.attr ? this.form.attr.id : '';
    this.buttons = this.form.buttons;
    this.reviewTitle = this.form.reviewTitle;

    _.each(this.inputFields, (value) => {
      if (value.attr !== undefined) {
        if (value.require) {
          let obj = JSON.parse(`{ "${value.attr.id}": false }`);
          Object.assign(this.isValidMap, obj);
        }
      }
    });
  }

  ngOnDestroy() {
    this.validationSubscription.unsubscribe();
  }

  get formInputs() {
    return _.sortBy(this.form.inputs || {}, (e) => e.order);
  }

  get formSummaries() {
    return _.sortBy(this.form.summaries || {} || {}, (e) => e.order);
  }

  get formButtons() {
    return _.sortBy((this.form.buttons || {}).inputs || {}, (e) => e.order);
  }

  // Maybe move these into accessors with redux backed values?
  getState(key, defaultValue) {
    this[key] = this.appActions.getData(`appState.${key}`, defaultValue);
  }

  // We can eventually mo
  loadState() {
    this.getState('showVal', {});
    this.getState('radioClick', {});
    this.getState('financialRadioClick', {});
    this.getState('promoShow', false);
    this.getState('helperShow', true);
  }

  saveState() {
    var payload = {
      showVal: this.showVal,
      radioClick: this.radioClick,
      financialRadioClick: this.financialRadioClick,
      promoShow: this.promoShow,
      helperShow: this.helperShow,
    };

    this.appActions.setData('appState', payload);
  }

  ngAfterViewInit() {
    // Run any functions in the queue after form factory is finished
    while (this.afterInitQueue.length > 0) {
      this.afterInitQueue.pop()();
    }

    // This is useful for state tracking
    this.finishedInit = true;
  }

  injectFormData() {
    let form = {
      name: 'OLA',
      type: null,
      step: this.form.stepNum,
      stepName: this.dtm.mapRouteName(this.router.url),
      items: [],
    };
    const tempData = this.getFromDataForDTM(form, this.formInputs);

    this.dtm.action = 'trackForm';
    this.dtm._digitalData.event.form = tempData;
  }

  getFromDataForDTM(form, inputs) {
    _.each(inputs, (input) => {
      if (input.attr) {
        const inputValue = this.inputValues[input.attr.id] || {
          isValid: true,
          value: null,
        };

        let inputErrorMessage = 'Is valid';
        if (input.msg !== undefined) inputErrorMessage = input.msg.fail;
        if (input.inputs && input.inputs.length > 0 && input.showUp === true)
          this.getFromDataForDTM(form, input.inputs);

        form.items.push({
          allow: input.allow !== false ? 'yes' : 'no',
          error: inputValue.isValid ? '' : 'Invalid',
          name: input.inputPath || input.attr.id,
          track: 'yes',
          value: input.allow !== false ? inputValue.value : '(Redacted)',
          inputErrorMessage,
        });
      }
    });

    return form;
  }

  async formBtnClicked(action, e) {
    // wait before executing button click, because the validation takes a bit
    const sleep = (ms) => new Promise(resolve => setTimeout(resolve, ms));
    await sleep(1000);

    if (
      action === 'next' ||
      action === 'login' ||
      action.match(/^submit(Primary|Contingent)Info/)
    ) {

      if (e.target.attributes.isAppSubmit) {
        const currentAppType = this.flowManager.getAppType() === 'tks' ? 'SD' : 'Robo';
        if (window.allytm) {
          window.allytm.event("customEvent", {
            name: "olaApplicationSubmit",
            attr: {
            currentAppType
            },
          });
        }
        e.target.disabled = true; // disable the button right away to avoid repeated submit clicks
        e.target.classList.add('spinner');
      }

      this.validation.validateForm(this.form);
      this.invalidFields = _.filter(this.isValidMap, (v, k) => v === false);
      const isValidMaplog = _.merge({}, this.isValidMap);

      for (const buf in isValidMaplog) {
        if (isValidMaplog[buf] === true) {
          delete isValidMaplog[buf];
        }
      }

      this.logService.logPageSubmit(this.router, isValidMaplog);

      if (this.invalidFields.length > 0) {
        const invalidIds = Object.keys(isValidMaplog);
        let launchErrs = [];
        this.submitError = true;

        this.flowManager.pageError = {
          hasErrors: true,
          errorCount: this.invalidFields.length,
        };

        const pageTop = document.querySelector('#page-errors');
        if (pageTop !== null) {
          scrollTo(document.body, pageTop.offsetTop, 0);
        }

        // Associate input IDs with their respective error messages for Launch event tracking
        const formInputs = Object.values(this.form.inputs);
        const hiddenInputs = formInputs
          .filter((i) => i.inputs && i.inputs.length)
          .flatMap((i) => i.inputs);
        const allInputs = [...formInputs, ...hiddenInputs];

        invalidIds.forEach((id) => {
          let field = _.find(allInputs, (input) => {
            return input.attr && input.attr.id === id;
          });
          if (field && field.msg) {
            const message = field.msg.fail;
            launchErrs.push({ id, message });
          }
        });

        // Fire Invalidated fields/messages to Launch
        this.dtm.triggerErrorEvent(launchErrs);
        this.dtm.userAction(action);

        return false;
      } else {
        if (this.form.stepTitle === BasicInfoLabel) {
          let pathTitle = null;
          let modalMsgLine1 = "We're unable to open an account for you.";
          let modalMsgLine2 = "We're only able to open accounts for U.S. citizens and current U.S. residents.";
          if (this.form.stepSubtitle === stepSubtitles.Personal) {
            pathTitle = InputPaths.PersonalInformation;
          } else if (this.form.stepSubtitle === stepSubtitles.JointHolderPersonal) {
            pathTitle = InputPaths.JointAccountInformation;
          } else if (this.form.stepSubtitle === stepSubtitles.MinorAccountInformation) {
            pathTitle = InputPaths.CustodialMinorInformation;
            modalMsgLine1 = "We're unable to open this custodial account for you.";
            modalMsgLine2 = "We're only able to open custodial accounts for minors who are U.S. citizens or current U.S. residents.";
          }

          if (pathTitle) {
            const usCitizenOrResident = this.appActions.getData(`${pathTitle}.usCitizenOrResident`) === true;
            const residencyStatus = this.appActions.getData(`${pathTitle}.permanentResident`) === true;
            if (!usCitizenOrResident || !residencyStatus) {
              this.modal.itinModal(
                modalMsgLine1,
                modalMsgLine2,
                true
              );
              return false;
            }
          }
        }

        this.flowManager.pageError = { hasErrors: false, errorCount: 0 };
        this.submitError = false;
        this.dtm.userAction(action);
        this.logService.logReduxState(this.appActions.getState());
      }
    }

    // Grab route fast! (not really though)
    const currentRoute = this.router.url.split('?')[0];

    //This payload is bubbling data up to routes
    let payload = {
      event: action,
      inputValues: this.inputValues,
      inputFields: this.inputFields,
    };

    // Only store data on next call
    if (action === 'next' || action === 'back') {
      // Store current account type
      const currentAccountType = this.appActions.getData(
        'ApplicationInformation.accountType'
      );

      // Clear out current data so order of the schema is maintained
      this.appActions.clearData(`review.${currentRoute}`);

      // Iterate over all definitions in the form and look for values with input path that are not null
      this._processValues((matchingInput, input) => {
        // We can skip pages without a review title
        // Need special logic for beneficiary
        if (
          this.reviewTitle !== undefined &&
          this.reviewTitle !== 'Beneficiary Information'
        ) {
          const fieldId = matchingInput.attr.id.replace(/\./, '_');
          const reviewPath = `review.${currentRoute}.${fieldId}`;
          const payload = {
            label: matchingInput.reviewLabel || matchingInput.label || fieldId,
            inputPath: matchingInput.inputPath,
          };

          if (matchingInput.optionsType !== undefined) {
            payload.optionsType = matchingInput.optionsType;
          }

          if (matchingInput.maskingType !== undefined) {
            payload.maskingType = matchingInput.maskingType;
          }

          this.appActions.setData(reviewPath, payload);
        }
      });

      // Time to format data into Redux for use in the Review Page
      if (this.reviewTitle !== undefined) {
        this.appActions.setData(`review.${currentRoute}.options`, {
          label: this.reviewTitle,
          route: currentRoute,
          id: this.reviewTitle.replace(/\s/g, '_'),
        });

        // Specific information local to Beneficiary since it needs to show grouped data
        if (this.reviewTitle === 'Beneficiary Information') {
          // Grab data out of store to format review data
          let beneInfo = this.appActions.getData('BeneficiaryInformation');
          if (beneInfo != null) {
            if (beneInfo.Primary != null) {
              for (let i in beneInfo.Primary) {
                let primary = beneInfo.Primary[i];
                let reviewPath = `review.${currentRoute}.primary${i}`;
                let payload = {
                  type: 'Primary',
                  label: `${primary.firstName} ${primary.lastName}`,
                  value: this._getBeneficiaryReviewData(primary),
                };
                this.appActions.setData(reviewPath, payload);
              }
            }
            if (beneInfo.Contingent != null) {
              for (let i in beneInfo.Contingent) {
                let contingent = beneInfo.Contingent[i];
                let reviewPath = `review.${currentRoute}.contingent${i}`;
                let payload = {
                  type: 'Contingent',
                  label: `${contingent.firstName} ${contingent.lastName}`,
                  value: this._getBeneficiaryReviewData(contingent),
                };
                this.appActions.setData(reviewPath, payload);
              }
            }
          }
        }
      }

      this.saveState();
    }

    // TODO: remove; we no longer have a cancel button
    if (action === 'cancel-app' && !this.flowManager.isSubmitting) {
      this.modal.cancelApplication();
    }

    if (action.split('-')[0] === 'modal') {
      const modal = {
        modalType: action.split('-')[1],
      };
      this.modal.generic(modal);
    }

    this.updateBtnClicked.emit({ action, event: e });
  }

  _getBeneficiaryReviewData(beneficiary) {
    const payload = {
      relationship: {
        label: 'Relationship',
        value: this.optionsService.getCodeName(
          'relationship',
          beneficiary.relationship
        ),
      },
      firstName: { label: 'First Name', value: beneficiary.firstName },
      lastName: { label: 'Last Name', value: beneficiary.lastName },
      address: {
        street: { label: 'Mailing Address', value: beneficiary.address.street },
        street2: {
          label: 'Address Line 2',
          value: beneficiary.address.street2,
        },
        city: { label: 'City', value: beneficiary.address.city },
        state: {
          label: 'State or US Territory',
          value: this.optionsService.getCodeName(
            'state',
            beneficiary.address.state
          ),
        },
        zip: { label: 'Zip', value: beneficiary.address.zip },
      },
      ssn: {
        label: 'Social Security Number',
        value: beneficiary.ssn,
        maskingType: 'ssn',
      },
      dob: { label: 'Birth Date', value: beneficiary.dob },
      email: { label: 'Email Address', value: beneficiary.email },
      percent: { label: 'Funds Allocation', value: `${beneficiary.percent}%` },
    };

    return payload;
  }

  // This instead works off input fields in order to maintain order for review
  _processValues(callback, fields = null) {
    fields = fields || this.inputFields;
    for (var i in fields) {
      let field = fields[i];
      if (field.attr !== undefined && field.inputPath !== undefined) {
        let input = this._getInputValue(field.attr.id);
        if (input !== null && input.value !== 'Select') callback(field, input);
      }

      if (field.inputs !== undefined) {
        this._processValues(callback, field.inputs);
      }
    }
  }

  _getInputValue(id) {
    for (let i in this.inputValues) {
      let input = this.inputValues[i];
      if (id === input.id) return input;
    }
    return null;
  }

  _getInputField(id, fields) {
    for (let i in fields) {
      let field = fields[i];
      if (field.attr && field.attr.id === id) return field;
      if (field.inputs !== undefined) {
        let sub = this._getInputField(id, field.inputs);
        if (sub !== null) return sub;
      }
    }

    return null;
  }

  updateOptionValue(event) {
    this.submitError = false;

    // Check for unauthed
    if (event.id && event.id.indexOf('primary') === 0) {
      this.isValidMap['allyAccount'] = true;
    }

    if (
      (event.id === 'depositEndType' && event.value === 'When I Cancel') ||
      (event.id === 'depositFrequency' &&
        event.value === this.optionsService.optionTypes.frequency.ONE_TIME.name)
    ) {
      delete this.isValidMap['depositEndDate'];
    }
    if (event.id === 'employedAddressCountry') {
      this.form.inputs.employmentShow.inputs.forEach((elem) => {
        if (
          elem.attr.id === 'employedAddressZip' ||
          elem.attr.id === 'employedAddressState'
        ) {
          elem.require = event.value === 'United States';
          this.isValidMap[elem.attr.id] = event.value === 'United States';
        }
      });
    }

    // storing data
    // @todo: Not sure we need this anymore
    let str = JSON.stringify(event);
    let obj = JSON.parse(`{ "${event.id}": ${str} }`);
    Object.assign(this.inputValues, obj);

    this.isValidMap[event.id] = event.isValid;
    this.valueChange.emit(event);

    // Page Level Errors
    this.flowManager.resetPageError();
  }

  hyperlinkClick(event) {
    this.valueChange.emit(event);
    this.hyperlinkClicked.emit(event);
  }

  validCheck(event) {
    if (event === 'clear') {
      this.isValidMap = {};
      return;
    }

    this.isValidMap[event.id] = event.isValid;
  }

  checkboxOptionValue(event) {
    // TODO: This needs to be reviewed at some point, the checks seem inconsistent
    let checkBoxID = event.target || event.srcElement;
    if (checkBoxID.id === 'mailAddressDifferent') {
      if (checkBoxID.checked === true) {
        _.each(this.inputFields, (value) => {
          if (value.inputType === 'checkbox' && value.showHide === true) {
            for (var input of value.inputs) {
              if (input.require) {
                let obj = JSON.parse(`{ "${input.attr.id}": false }`);
                Object.assign(this.isValidMap, obj);
              }
            }
          }
        });
      } else {
        _.each(this.inputFields, (value) => {
          if (value.attr !== undefined && value.showHide === true) {
            for (var input of value.inputs) {
              delete this.isValidMap[input.attr.id];
            }
          }
        });
      }
    }
    // Regardless of checkbox Id, we need to save the value
    let payload = {
      id: checkBoxID.id,
      isValid: event.isValid !== undefined ? event.isValid : true,
      value: checkBoxID.checked,
    };

    this.updateOptionValue(payload);
  }

  selectOptionValue(event) {
    this.updateOptionValue(event);
    if (event.id === 'allyAccount') {
      if (event.value === 'Add a Non-Ally Account') {
        // This part is terrible, need to be changed
        this.isValidMap['primaryRoutingNumber'] = false;
        this.isValidMap['primaryBankAccountNumber'] = false;
        this.isValidMap['primaryBankName'] = false;
      } else {
        this.updateOptionValue(event);
      }
    }
    if (
      event.showHide !== undefined &&
      (event.id === 'employmentStatus' || event.id === 'jointEmploymentStatus')
    ) {
      this.showVal[`${event.id}_Show`] =
        event.showHide.show === false ? false : true;
      this.updateOptionValue(event);
    }

    this.valueChange.emit(event);
  }

  _setRiskTolerance(value, valid = []) {
    const riskTolerance = document.getElementsByName('riskTolerance');

    // If element cannot be found (not loaded yet)
    // push function to queue that executes when the form factor is all loaded
    if (riskTolerance.length === 0) {
      this.afterInitQueue.push((cb) => this._setRiskTolerance(value, valid));
      return;
    }

    const types = ['High', 'Medium', 'Low'];
    if (valid.indexOf(value) === -1) valid.push(value);

    let selectedOption = document.getElementById(value.toLowerCase());

    if (valid.indexOf(riskTolerance[0].innerHTML) === -1)
      riskTolerance[0].innerHTML = value;
    selectedOption.selected = true;

    const payload = {
      id: 'riskTolerance',
      validationType: 'risk_tolerance',
      value: value,
      isValid: true,
      showHide: {
        id: value.toLowerCase(),
        name: value,
        selected: true,
      },
    };

    this.appActions.setData('GoalInformation.riskTolerance', value);

    this.selectOptionValue(payload);

    for (const type of types) {
      let option = document.getElementById(type.toLowerCase());
      option.disabled = valid.indexOf(type) === -1;
    }
  }

  radioOptionValue(event) {
    const radioID =
      event.show.target.id ||
      (event.show.srcElement !== undefined && event.show.srcElement.id);
    if (
      radioID === 'investmentObjective' ||
      event.id === 'investmentObjective'
    ) {
      this.flowManager.setinvestmentSpeculationGroup(event.value);
      switch (event.value) {
        case 'speculation':
        case 'maximumGrowth':
          this._setRiskTolerance('High');
          break;
        case 'growth':
          this._setRiskTolerance('Medium');
          break;
        case 'growthAndIncome':
          this._setRiskTolerance('Medium', ['High']);
          break;
        case 'income':
        case 'balanced':
          this._setRiskTolerance('Low');
          break;
        default:
          break;
      }
    }

    // @todo: Move some of these state into flow manager and trigger them off their own route
    if (radioID === 'yes2') {
      this.radioClick[`${event.id}_Show`] = true;
    } else if (radioID === 'no2') {
      this.radioClick[`${event.id}_Show`] = false;
    }

    if (
      radioID === 'isExperiencedYes' ||
      radioID === 'experiencedTradingSecuritiesYes'
    ) {
      this.financialRadioClick[`${event.id}_Show`] = true;
    }

    if (
      radioID === 'isExperiencedNo' ||
      radioID === 'experiencedTradingSecuritiesNo'
    ) {
      this.financialRadioClick[`${event.id}_Show`] = false;
    }

    // These need to occur last so valid map works correctly
    this.updateOptionValue(event);
    this.valueChange.emit(event.show);
  }

  modelLinkClicked(event) {
    this.modal.setModalData(event);
  }

  mouseTipOver(event, data) {
    if (data.hasGroupToolTip === true) {
      document.getElementById(`${data.attr.id}_tooltip`).style.display =
        'block';
    }
  }

  mouseTipOut(event, data) {
    if (data.hasGroupToolTip === true) {
      document.getElementById(`${data.attr.id}_tooltip`).style.display = 'none';
    }
  }

  forgotPassword(event) {
    this.forgetPasswordClicked.emit(event);
  }

  openModal() {
    this.launchModal.emit();
  }

  backToFundingChoices() {
    this.appActions.clearData('FundAccount');
    this.appActions.clearData('Fundingchoices');
    if (this.flowManager.hasDepositAccounts) {
      this.router.navigate(['/funding-choices-streamline'], {
        queryParamsHandling: 'preserve',
      });
    } else {
      this.router.navigate(['/funding-choices'], {
        queryParamsHandling: 'preserve',
      });
    }
  }
}